import { styled } from '@stitches/react'

export const Main = styled('main', {
  padding: '1rem 5rem'
})